import {useMutation, useQueryClient} from '@tanstack/react-query';
import http from "@framework/utils/http";
import {API_ENDPOINTS} from "@framework/utils/api-endpoints";

const logout = async () => {
  const {data} = await http.post(API_ENDPOINTS.LOGOUT);
  return data
};

export const useLogoutMutation = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: logout,
    onSuccess: async (_data) => {
      await client.invalidateQueries({queryKey: [API_ENDPOINTS.USERS]})
      await client.invalidateQueries({queryKey: [API_ENDPOINTS.PRODUCTS]})
    },
    onError: async (data) => {
      console.log(data, 'logout error response');
    },
  });
};
